import {
  appointmentStatusBadgeClassName,
  resolveAppointmentStatusPresentation,
  type AppointmentStatusTone,
} from '../../domain/appointments/appointmentStatusPresentation'

export function StaffStatusBadge({
  status,
  statusLabel,
  tone,
  label,
}: {
  status?: string | null
  statusLabel?: string | null
  tone?: AppointmentStatusTone
  label?: string
}) {
  const resolved = resolveAppointmentStatusPresentation(status, statusLabel)
  const finalTone = tone ?? resolved.tone
  const finalLabel = label ?? resolved.label

  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${appointmentStatusBadgeClassName(finalTone)}`}>
      {finalLabel}
    </span>
  )
}
